import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SESSION_PROVIDER } from './session-provider';

/** Allows the route when authenticated; otherwise starts the login redirect and cancels nav. */
export const authGuard: CanActivateFn = async (_route, state) => {
  const session = inject(SESSION_PROVIDER);
  if (session.isAuthenticated()) {
    return true;
  }
  await session.login(state.url);
  return false;
};
